import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { $recipientMandatoryFieldsStore } from '@lib/store';
import { cn, PaletteUtils, ValidateUtils } from '@shared/utils';
import { BaseInput, Text } from '@shared/widgets';

export interface CompanyFormData {
  companyName: string;
  email: string; // insi_email
}

interface CompanyFormBlockProps {
  className?: string;
}

export const CompanyFormBlock = (props: CompanyFormBlockProps) => {
  const mandatoryFields = useUnit($recipientMandatoryFieldsStore.store);

  const { control } = useFormContext<CompanyFormData>();

  const { t } = useTranslation('payments');

  return (
    <div className={cn('flex flex-col gap-2', props.className)}>
      <Text className={cn(PaletteUtils.isVcfcPalette && 'dark:text-white/50')}>{t('form.titles.companyDetails')}</Text>
      <Controller
        name='companyName'
        control={control}
        rules={{
          required: t('errors.form.required', { ns: 'common' }),
          maxLength: { value: 100, message: t('errors.form.maxCharacters', { ns: 'common', max: 100 }) },
          pattern: {
            value: ValidateUtils.alphaNumericRegex,
            message: t('errors.form.alphaNumericFormat', { ns: 'common', field: t('form.placeholders.companyName') }),
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <BaseInput
            {...field}
            label={t('form.placeholders.companyName')}
            placeholder={t('form.placeholders.companyName')}
            required
            error={error?.message}
          />
        )}
      />
      {mandatoryFields.data.includes('insi_email') && (
        <Controller
          name='email'
          control={control}
          rules={{
            maxLength: { value: 100, message: t('errors.form.maxCharacters', { ns: 'common', max: 100 }) },
            pattern: { value: ValidateUtils.emailRegex, message: t('errors.form.email.invalidFormat', { ns: 'common' }) },
          }}
          render={({ field, fieldState: { error } }) => (
            <BaseInput
              {...field}
              type='email'
              label={t('placeholders.email', { ns: 'common' })}
              placeholder={t('placeholders.email', { ns: 'common' })}
              error={error?.message}
            />
          )}
        />
      )}
    </div>
  );
};
